<script lang="ts">
  import { Icon } from '$shared/components';

  interface Props {
    warnText?: string;
    icon?: string;
    hidden?: boolean;
  }

  let { warnText = '', icon = 'icon-alert-triangle', hidden = false }: Props = $props();
</script>

<div class="comp-warn" class:hidden>
  <div class="icon"><Icon value={icon} /></div>
  <div class="text">{warnText}</div>
</div>

<style>
  .comp-warn,
  .comp-warn .icon {
    display: flex;
    align-items: flex-start;
  }
  .comp-warn .text {
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    margin-left: 8px;
    color: var(--grey-medium);
  }
  .comp-warn.hidden {
    display: none;
  }
</style>
